import { prop, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { User } from "../../users/_types/user";
import { CaseNote } from "../../cases/_types/case-note";
import { TaskComment } from "./task-comment";

export class Task extends Resource {
    public override type = 'tasks';

    @prop()
    public userId!: string;

    public user!: User;

    @prop()
    public caseNoteId!: string;

    public caseNote!: CaseNote;

    @prop()
    @required()
    public description!: string;

    @prop()
    public date: Date = new Date();

    @prop()
    public isCompleted: boolean = false;

    @prop()
    public notifyStatusChanges: boolean = false;

    @prop()
    public isUrgent: boolean = false;

    @prop()
    public createdByUser!: User;

    // Comentarios (respuestas) de la tarea (include 'comments').
    public comments!: TaskComment[];
}